import React, { useMemo } from 'react';
import { Url } from '@wix/da-url';
import { PapiUser } from '@wix/da-types-papi';
import Ellipsis from '@wix/da-shared-react/pkg/Icons/Ellipsis';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import IconButtonWithContextMenu from '@wix/da-shared-react/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { useWatchButton } from '@wix/da-shared-react/pkg/WatchButton/useWatchButton';
import { useTranslation } from 'react-i18next';

export interface Props {
  group: PapiUser;
  className?: string;
  requestLeave: (group: PapiUser) => void;
}

const GroupMenu: React.FC<Props> = ({ group, className, requestLeave }) => {
  const { t } = useTranslation();
  const { isWatching, biData, onClick } = useWatchButton(
    group,
    group.isWatching
  );

  const dropdownItems = useMemo(
    () => [
      {
        label: t('subnavigation.button.groupDropdown.items.messageAdmins'),
        link: Url.userNoteLink(group.username),
      },
      {
        label: isWatching
          ? t('subnavigation.button.groupDropdown.items.unwatch')
          : t('subnavigation.button.groupDropdown.items.watch'),
        biData,
        onClick,
      },
      group.extendedGroup?.isIngroup && {
        label: t('subnavigation.button.groupDropdown.items.leaveGroup'),
        onClick: () => requestLeave(group),
      },
    ],
    [group, biData, isWatching, onClick, requestLeave, t]
  );

  return (
    <IconButtonWithContextMenu
      items={dropdownItems}
      className={className}
      withButton
    >
      <Ellipsis size={IconSize.MEDIUM} />
    </IconButtonWithContextMenu>
  );
};
GroupMenu.displayName = 'GroupMenu';

export default GroupMenu;
